module.exports = __webpack_public_path__ + "img/benefit-statistic.4863d582.jpg";